import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import StepOneZipUploader from './Steps/StepOneZipUploader'
import StepThreeProductCreator from './Steps/StepThreeProductCreator'
import { Button, Container, Dimmer, Loader } from 'semantic-ui-react'
import { Lineage } from '../../types'
import { ProductForm } from '../../redux/types/products'
import { AppState } from '../../redux/store'
import { clear } from '../../redux/actions/batchProductCreator'

export interface CsvProduct {
  Amount: string
  Brand: string
  'Brand Subtype': string
  'Product Type': string
  'CBD mg': string
  Description: string
  Dosage: string
  'Product Name': string
  Lineage: Lineage
  'Product Subtype': string
  'THC mg': string
  'Quantity Units': string
  'Quantity Value': string
  Photo: string
  Aliases: string
  'Net Weight g': string
}

const toTitleCase = (str: string) =>
  str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  })

/**
 * Transforms the row objects that result from parsing the batch create product csv to
 * the shape expected by the product form.
 */
const csvProductToProductForm = (p: CsvProduct, imageUrls: string[]): ProductForm => {
  return {
    net_weight_grams: p['Net Weight g'],
    notice_status: null,
    product_brand_id: '',
    removal_status: null,
    store_count: null,
    amount: p['Amount'],
    brand: p['Brand'],
    kind_subtype: p['Brand Subtype'],
    kind: p['Product Type']?.toLowerCase(),
    cbd_dosage_milligrams: p['CBD mg'],
    description: p['Description'],
    dosage: p['Dosage'],
    name: p['Product Name'],
    category: p['Lineage']?.toLowerCase(),
    root_subtype: p['Product Subtype'] ? toTitleCase(p['Product Subtype']) : '',
    thc_dosage_milligrams: p['THC mg'],
    quantity_units: p['Quantity Units'],
    quantity_value: p['Quantity Value'],
    aliases_attributes: [...p['Aliases'].split(';').map((name: string) => ({ name }))].filter(
      (each) => each.name && each.name.length > 0
    ),
    image_urls: imageUrls,
    store_id: null,
  }
}

const getS3ImagePath = (p: CsvProduct, zipFileData: any) => {
  if (!zipFileData) return []
  return p['Photo'] ? p['Photo'].split(';').map((url) => zipFileData[url.trim()]) : []
}

const BatchProductCreator = () => {
  const zipFileData = useSelector((state: AppState) => state.batchProductCreator.zipFileResult)
  const csvFileData = useSelector((state: AppState) => state.batchProductCreator.csvFileResult)
  const loading = useSelector((state: any) => state.batchProductCreator.loading)

  const dispatch = useDispatch()

  const reset = () => {
    dispatch(clear())
  }

  function getContainerInners() {
    if (loading) {
      return (
        <Dimmer active>
          <Loader />
        </Dimmer>
      )
    } else {
      if (!csvFileData) {
        return <StepOneZipUploader />
      } else {
        if (!zipFileData) {
          alert(
            'you are uploading without images. any photo references in your csv will be ignored.'
          )
        }
        return (
          <StepThreeProductCreator
            products={
              csvFileData?.products
                ? csvFileData.products.map((p: any) =>
                    csvProductToProductForm(p, getS3ImagePath(p, zipFileData))
                  )
                : []
            }
          />
        )
      }
    }
  }

  return (
    <Container fluid={true} style={{ marginTop: '20px' }}>
      <div style={{ padding: '0px 20px' }}>
        <Button
          fluid
          color="yellow"
          onClick={() => reset()}
          style={{
            display: !!csvFileData || !!zipFileData ? '' : 'none',
            margin: '10px 0',
          }}
        >
          Reset Batch Product Creator Data
        </Button>
        {getContainerInners()}
      </div>
    </Container>
  )
}

export default BatchProductCreator
